import * as Types from "@graphql/generated/graphql.g";
import {
  UserFragment,
  useCurrentUserQuery,
  useUpdateUserMutation,
  useUserQuery,
} from "@graphql/users/users.g";
import { toast } from "react-toastify";

import { UserForm, UserFormValues } from "@components/Forms";

type Props = {
  userId: string;
  onUpdateUserSuccess?: (data: UserFragment) => Promise<void> | void;
};

export const UpdateUserForm = ({ userId, onUpdateUserSuccess }: Props) => {
  const userQuery = useUserQuery({ userId });
  const currentUserQuery = useCurrentUserQuery();
  const updateUserMutation = useUpdateUserMutation();
  const updateUser = updateUserMutation.mutateAsync;

  const user = userQuery.data?.user ?? undefined;
  const currentUser = currentUserQuery.data?.currentUser;
  const isCurrentUser = currentUser?.id === userId;

  const onSubmit = async (values: UserFormValues) => {
    const input = isCurrentUser
      ? { id: userId, name: values.name }
      : { id: userId, name: values.name, email: values.email };

    const data = await updateUser({
      input: input as Types.UpdateUserMutationInput,
    });

    const updatedUser = data?.updateUser?.user;

    if (!updatedUser) return;

    toast.success("User updated successfully");

    await onUpdateUserSuccess?.(updatedUser);
  };

  return (
    <UserForm
      onSubmit={onSubmit}
      values={user}
      submitText="Update"
      disableEmail={isCurrentUser}
    />
  );
};
